import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getSimulatorRecommendationData } from 'gqlQueries/priceSimulator';
import { simulationOutputDataParser } from 'parser/priceSimulator/priceSimulatorDataParser';
import { getConfig } from 'utils/helperMethods';
import { UserContext } from 'contexts/ConfigContext';
const errorMessage: string = 'Something went wrong!';

function useFetchRecommendationValues() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any>(null);
    const offsetRef = useRef(0);
    const { appConfig } = useContext(UserContext);

    const { recommendationKeyMapping } = getConfig('priceSimulator', appConfig);

    const [fetchRecommendationValues] = useLazyQuery(getSimulatorRecommendationData, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
        fetchPolicy: 'network-only',
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getSimulatorRecommendationData } = payload;
            //if data present parse it
            if (getSimulatorRecommendationData?.recommendationData?.length > 0) {
                const recommendationData: any = simulationOutputDataParser(
                    getSimulatorRecommendationData?.recommendationData,
                    recommendationKeyMapping,
                );
                setData(recommendationData);
                return;
            }
            setData([]);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchRecommendationValues: (variables: any) => {
            offsetRef.current = variables.variables.offset;
            setLoading(true);
            setError(null);
            fetchRecommendationValues(variables);
        },
    };
}

export { useFetchRecommendationValues };
